export enum CONNECTION_HUB_CONNECTION_STATUSES {
  PRISTINE = 'PRISTINE',
  CONNECTED = 'CONNECTED',
  NOT_CONNECTED = 'NOT_CONNECTED',
  ERROR = 'ERROR',
}

export class ConnectionHubStoreModelGroup {
  name: string = null;
  code: string = null;
  storeModel: string[] = null;
  status: CONNECTION_HUB_CONNECTION_STATUSES = null;
  relatedProviderList: ConnectionHubStoreModelGroup[] = [];
}

export interface ConnectionHubProviderSyncEntity<T> {
  // Objects coming from the external provider
  contributors?: T[];
  // Objects alrrweady present in user's account
  base?: T;
  // Resulting object
  merged?: T;
}

// Instantiate a real Map
export const ConnectionHubStatusesSeverityMapping = new Map<
  CONNECTION_HUB_CONNECTION_STATUSES,
  string
>([
  [CONNECTION_HUB_CONNECTION_STATUSES.PRISTINE, 'info'],
  [CONNECTION_HUB_CONNECTION_STATUSES.CONNECTED, 'success'],
  [CONNECTION_HUB_CONNECTION_STATUSES.NOT_CONNECTED, 'warn'],
  [CONNECTION_HUB_CONNECTION_STATUSES.ERROR, 'danger'],
]);

export const ConnectionHubStatusesTranslationMapping = new Map<
  CONNECTION_HUB_CONNECTION_STATUSES,
  string
>([
  [CONNECTION_HUB_CONNECTION_STATUSES.PRISTINE, 'connection_hub.statuses.PRISTINE'],
  [CONNECTION_HUB_CONNECTION_STATUSES.CONNECTED, 'connection_hub.statuses.CONNECTED'],
  [CONNECTION_HUB_CONNECTION_STATUSES.NOT_CONNECTED, 'connection_hub.statuses.NOT_CONNECTED'],
  [CONNECTION_HUB_CONNECTION_STATUSES.ERROR, 'connection_hub.statuses.ERROR'],
]);
